module.exports = __webpack_public_path__ + "static/img/sm-logo3.6959531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/sm-logo3.png
// module id = bYjp
// module chunks = 1